import { render } from "./SEUDashboards.vue?vue&type=template&id=97d30334"
import script from "./SEUDashboards.vue?vue&type=script&lang=js"
export * from "./SEUDashboards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__